module.exports = __webpack_public_path__ + "static/img/double-wall-outlet-mk-3_256.903e8a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/double-wall-outlet-mk-3_256.png
// module id = S5Ms
// module chunks = 0